export const DEFAULT_KPI_THRESHOLDS = {
	CONFIRMED: 1.5,
	DELIVERED: 0.8,
};
